import { gql } from '@apollo/client';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

export const AUTOCOMPLETE = gql`
  query Autocomplete(
    $resource: String!
    $term: String!
    $name: String
  ) {
    autocomplete(
      resource: $resource
      term: $term
      name: $name
    ) {
      assets {
        ${CORE_ASSET_FIELDS}
        seller { name }
        soldOn
        titleReleaseWarning
        buyer { id, name, street, city, state, postalCode { formatted }, email }
      }
      buyers {
        id
        name
        displayName
        fullDisplayName
      }
      commissions {
        id
        name
      }
      locations {
        id
        street
        city
        state
        postalCode { formatted, value }
      }
      makes {
        type
        label
      }
      models {
        type
        label
      }
      sales {
        id
        name
        saleOn
      }
      sellers {
        id
        name
      }
      users {
        id
        firstName
        lastName
        fullName
      }
      vendors {
        id
        name
      }
    }
  }
`;
